<template>
  <v-expansion-panels flat hover accordion v-model="visible">
    <v-expansion-panel>
      <v-expansion-panel-header class="v-expansion-panel-header">
        <span v-if="title">{{ title }}</span>
        <slot name="title" v-else />
      </v-expansion-panel-header>
      <v-expansion-panel-content class="v-expansion-panel-content">
        <slot />
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>

export default {
  name: "ExpansionPanel",
  props: {
    title: {
      type: String,
      default: null
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: (this.expanded) ? 0 : 1
    };
  }
};
</script>

<style scoped>
.v-expansion-panel-header {
  padding: 0px 8px;
  min-height: 32px;
}

.v-expansion-panel-content {
  margin-left: -24px;
  margin-right: -16px;
  padding: 0px 0px;
  padding-top: 14px;
}

</style>